(function ($) {
  $(document).ready(function ($) {
    // Creating & Setting Cookies
    function getCookie(cname) {
      var name = cname + '=';
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return '';
    }

    function setCookie(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = 'expires=' + d.toUTCString();
      document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }
    // END Creating & Setting Cookies

    //Logic for showing & hiding notification based on Cookies
    if (getCookie('notificationHide') == 'true') {
      console.log('notificationHide: true');
      $('body').removeClass('show-notification');
      $('#notification-msg').remove();
    } else {
      console.log('notificationHide: false');
      if ($('#notification-msg').length) {
        $('body').addClass('show-notification');
      }
    }
    // END – Logic for showing & hiding notification based on Cookies

    // Notification Message's close Button is clicked.
    // Function to handle resizing and initial loading
    function handleResize() {
      var $msg = $('#notification-msg');
      var $header = $('#header');
      var menuHeight = $header.outerHeight(true);

      if ($msg.length) {
        var msgHeight = $msg.outerHeight(true);
        var totalHeight = msgHeight + menuHeight;
        $('body').css('margin-top', totalHeight);
        $header.css('top', msgHeight);
      } else {
        $('body').css('margin-top', menuHeight);
      }
    }

    // Notification Message's close Button is clicked
    $('#notification-dismiss').click(function (event) {
      // Set a cookie
      setCookie('notificationHide', 'true', 0.25);
      $('body').removeClass('show-notification');
      $('#notification-msg').remove();
      $('#header').css('top', 0);

      // Recalculate heights since notification is removed
      handleResize();
    });

    // Handle on document ready
    $(document).ready(function () {
      handleResize();
    });

    // Handle on window resize
    $(window).resize(function () {
      handleResize();
    });
    // END – Notification Message's close Button is clicked.
  });
})(jQuery);
